export default __webpack_public_path__ + "static/media/email-svgrepo-com.09f59b22.svg";